'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.get = get;
exports.create = create;
exports.submit = submit;
exports.copy = copy;
exports.list = list;
exports.ordersInJob = ordersInJob;
exports.routing = routing;
exports.transportModeDetails = transportModeDetails;
exports.optimiseRoute = optimiseRoute;
exports.markAsFeedbackGiven = markAsFeedbackGiven;
exports.getCalculatedScheduledFor = getCalculatedScheduledFor;
exports.removeWaypointConstraint = removeWaypointConstraint;
exports.getEAQ = getEAQ;

var _http = require('../network/http');

var _http2 = _interopRequireDefault(_http);

var _osrmClient = require('../network/osrm-client');

var _osrmClient2 = _interopRequireDefault(_osrmClient);

var _modelProvider = require('../model-provider');

var _modelProvider2 = _interopRequireDefault(_modelProvider);

var _waypoints = require('../customer/waypoints');

var _waypoints2 = _interopRequireDefault(_waypoints);

var _pagination = require('../services/pagination');

var _apiClient = require('../network/api-client');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  PARTNER: '/partner',
  PARTNER_JOBS: '/partner/jobs'

  /**
   * Wrapper for `/partner/jobs` API endpoint
   */
};var jobs = {
  get: get,
  create: create,
  list: list,
  ordersInJob: ordersInJob,
  routing: routing,
  submit: submit,
  cancelJob: cancelJob,
  cancellationReasons: cancellationReasons,
  cancelJobState: cancelJobState,
  transportModeDetails: transportModeDetails,
  optimiseRoute: optimiseRoute,
  copy: copy,
  markAsFeedbackGiven: markAsFeedbackGiven,
  getEAQ: getEAQ,
  getCalculatedScheduledFor: getCalculatedScheduledFor,
  removeWaypointConstraint: removeWaypointConstraint
};

exports.default = jobs;

/**
 * Get a job
 * @param {Object} job - Job model.
 * @returns {promise} containing the entity object of job
 */

function get(jobId) {
  return _http2.default.get(API.PARTNER_JOBS + '/' + jobId);
}

/**
 * Creates a new job
 * @param {Object} job - Job model.
 * @returns {promise} containing the entity object of job
 */
function create() {
  var job = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _apiClient.post)({ route: API.PARTNER_JOBS, data: job });
}

/**
 * Submits a pending job
 * @param {Object} job - Job model.
 * @returns {promise} containing the entity object of job
 */
function submit(jobId) {
  return (0, _apiClient.post)({ route: API.PARTNER_JOBS + '/' + jobId + '/submissions' });
}

/**
 * Copies a completed job into a new job
 * @param {Object} jobId - Job id.
 * @returns {promise} containing the entity object of job
 */
function copy(jobId) {
  return (0, _apiClient.post)({ route: API.PARTNER_JOBS + '/' + jobId + '/copy' });
}

/**
 * Get all partner jobs
 * @param {Object} attrs - Attributes
 * @param {boolean} [attrs.includeEntities] - Inlude nested entities in Job (default 'false')
 * @returns {promise} containing the entity array of jobs
 */
function list() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { includeEntities: false };
  var includeEntities = attrs.includeEntities,
      others = (0, _objectWithoutProperties3.default)(attrs, ['includeEntities']);

  if (includeEntities) return jobsWithEntitiesWrapper((0, _extends3.default)({}, others));

  return _http2.default.get(API.PARTNER_JOBS, (0, _extends3.default)({}, others)).then(function (response) {
    return (0, _pagination.modelPaginatedResult)(response, _modelProvider2.default.Job);
  });
}

/**
 * Get all orders within a job
 * @param {Object} attrs - Attributes
 * @param {string} [attrs.jobId] - job number to get orders from
 * @returns {promise} containing the entity array of orders
 */
function ordersInJob(_ref) {
  var jobId = _ref.jobId;

  return _http2.default.get('/partner/jobs/' + jobId + '/orders');
}

/**
 * Get OSRM routing for waypoints
 * @param {Object} attrs - Attributes
 * @param {array} [attrs.waypoints] - waypoints with location and coords
 * @param {array} [attrs.additionalCoordinates] - which not come from waypoints [eg. quiqie location]
 * @param {array} [attrs.transportMode] - transport mode (car, scooter, bicycle)
 * @param {array} [attrs.geometries] - format to return osrm (default geojson)
 * @returns {promise} containing an osrm object
 */

// eslint-disable-next-line no-shadow
function routing(_ref2) {
  var _ref2$waypoints = _ref2.waypoints,
      waypoints = _ref2$waypoints === undefined ? [] : _ref2$waypoints,
      _ref2$additionalCoord = _ref2.additionalCoordinates,
      additionalCoordinates = _ref2$additionalCoord === undefined ? [] : _ref2$additionalCoord,
      transportMode = _ref2.transportMode,
      _ref2$geometries = _ref2.geometries,
      geometries = _ref2$geometries === undefined ? 'geojson' : _ref2$geometries;

  var coords = [].concat(additionalCoordinates, waypoints.map(function (waypoint) {
    var waypointCoords = waypoint.location.coords;
    if (Array.isArray(waypoint.location)) waypointCoords = waypoint.location; // for OSRM response

    return waypointCoords[0] + ',' + waypointCoords[1];
  }));

  return _osrmClient2.default.get({
    route: '/route/v1/' + transportMode + '/' + coords.join(';'),
    params: { geometries: geometries }
  }).then(function (response) {
    if (additionalCoordinates.length && transportMode && response.waypoints && response.waypoints.length) {
      response.waypoints[0].transportMode = transportMode; // this waypoint is a courier
    }
    return response;
  });
}

/**
 * @access private
 * @param {Object} params - params used in GET request
 * @returns {array} containing an Job objects with nested entities
 */
function jobsWithEntitiesWrapper() {
  var _this = this;

  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _http2.default.get(API.PARTNER_JOBS, params).then(function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(response) {
      var res;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              res = (0, _extends3.default)({}, response);
              _context2.next = 3;
              return _promise2.default.all(response.results.map(function () {
                var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(job) {
                  var waypointJob, waypointOrderJob;
                  return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return waypointsInJobWrapper(job);

                        case 2:
                          waypointJob = _context.sent;
                          _context.next = 5;
                          return ordersInJobWrapper(waypointJob);

                        case 5:
                          waypointOrderJob = _context.sent;
                          return _context.abrupt('return', waypointOrderJob);

                        case 7:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x5) {
                  return _ref4.apply(this, arguments);
                };
              }()));

            case 3:
              res.results = _context2.sent;
              return _context2.abrupt('return', res);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }()).then(function (response) {
    return (0, _pagination.modelPaginatedResult)({ results: response.results, totalPages: response.totalPages }, _modelProvider2.default.Job);
  });
}

/**
 * @access private
 * @param {Object} Job - Job model
 * @returns {array} containing an Job objects with nested waypoints
 */
function waypointsInJobWrapper() {
  var job = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = job.id;


  return _waypoints2.default.getAll({ jobId: id }).then(function (waypointList) {
    job.waypoints = waypointList;
    return job;
  });
}

/**
 * @access private
 * @param {Object} Job - Job model
 * @returns {array} containing an Job objects with nested waypoints
 */
function ordersInJobWrapper() {
  var job = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = job.id;


  return ordersInJob({ jobId: id }).then(function (orders) {
    job.orders = orders;
    return job;
  });
}

/**
 * @param {String} jobId - The id or slug of the job
 * @returns {Object} cancellation result
 */
function cancelJob(jobId, payload) {
  return (0, _apiClient.post)({
    route: API.PARTNER_JOBS + '/' + jobId + '/cancellations',
    data: payload
  });
}

/**
 * @param {String} jobId - The id or slug of the job
 * @returns {Object} cost of the cancellation
 */
function cancelJobState(jobId) {
  return _http2.default.get(API.PARTNER_JOBS + '/' + jobId + '/cancellations');
}

/**
 * @param {String} jobId - The id or slug of the job
 * @returns {Object} cancellation information
 */
function cancellationReasons() {
  return _http2.default.get(API.PARTNER + '/cancellation_reasons');
}

/**
 * Get the tranport mode details of a partner job
 * @param {object} licence plate
 * @returns {promise} containing an object with transport mode details
 */
function transportModeDetails(jobId) {
  return _http2.default.get(API.PARTNER_JOBS + '/' + jobId + '/transport_mode_details');
}

function optimiseRoute(jobId) {
  return _http2.default.get(API.PARTNER_JOBS + '/' + jobId + '/optimise_route');
}

/**
 * Marks the job with feedback given status
 * @param {String} jobId - The id or slug of the job
 * @returns {Promise}
 */
function markAsFeedbackGiven(jobId) {
  return (0, _apiClient.put)({ route: API.PARTNER_JOBS + '/' + jobId + '/feedback_given', data: { feedback_given: true } });
}

/**
 * Returns the estimated Pickup time of the order
 * @param {String} jobId - The id or slug of the job
 * @returns {Promise}
 */
function getCalculatedScheduledFor(jobId) {
  return (0, _apiClient.put)({ route: API.PARTNER_JOBS + '/' + jobId + '/calculate_scheduled_for' });
}

/**
 * Remove the constraints of the waypoint
 * @param {String} jobId - The id or slug of the job
 * @param {String} waypointId - The id of the waypoint
 * @returns {Promise}
 */
function removeWaypointConstraint(params) {
  return (0, _apiClient.remove)({
    route: API.PARTNER_JOBS + '/' + params.jobId + '/waypoints/' + params.waypointId + '/constraint'
  });
}

/**
 * Retrieve job's earliest available quiqee's times
 * @param jobId
 * @returns {Promise}
 */
function getEAQ(jobId) {
  return _http2.default.get(API.PARTNER_JOBS + '/' + jobId + '/eaqs');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/partner/jobs.js
// module id = 1071
// module chunks = 0